import React, { useMemo } from 'react';
import Joyride from 'react-joyride';
import { useTheme } from '../../contexts/ThemeContext';

/** Brand amber (matches theme/tokens.css --amber) */
const AMBER = '#E09B1A';

export default function ProductTour({
  steps,
  run,
  onFinish,
  tourName,
}) {
  const { resolvedTheme } = useTheme();
  const isLight = resolvedTheme === 'light';

  const joyrideStyles = useMemo(
    () => ({
      options: {
        primaryColor: AMBER,
        backgroundColor: isLight ? '#FFFFFF' : '#161820',
        textColor: isLight ? '#0C0D10' : '#EDEAE3',
        overlayColor: isLight ? 'rgba(7, 8, 10, 0.42)' : 'rgba(0, 0, 0, 0.78)',
        arrowColor: isLight ? '#FFFFFF' : '#161820',
        zIndex: 10000,
      },
      tooltip: {
        borderRadius: 12,
        padding: 20,
        maxWidth: '400px',
        border: isLight ? '1px solid rgba(0, 0, 0, 0.08)' : '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: isLight
          ? '0 12px 40px rgba(7, 8, 10, 0.12)'
          : '0 12px 40px rgba(0, 0, 0, 0.45)',
      },
      tooltipContainer: {
        textAlign: 'left',
      },
      tooltipTitle: {
        fontSize: '1.2rem',
        fontWeight: 700,
        marginBottom: 10,
        color: isLight ? '#07080A' : '#EDEAE3',
      },
      tooltipContent: {
        fontSize: '1rem',
        lineHeight: 1.6,
        color: isLight ? '#0C0D10' : '#EDEAE3',
      },
      tooltipFooter: {
        color: isLight ? '#3E424E' : 'rgba(237, 234, 227, 0.75)',
      },
      buttonNext: {
        backgroundColor: AMBER,
        color: '#07080A',
        borderRadius: 8,
        padding: '10px 20px',
        fontSize: '1rem',
        fontWeight: 600,
      },
      buttonBack: {
        color: isLight ? '#3E424E' : 'rgba(237, 234, 227, 0.75)',
      },
      buttonSkip: {
        color: isLight ? '#3E424E' : 'rgba(237, 234, 227, 0.65)',
      },
      buttonClose: {
        color: isLight ? '#3E424E' : 'rgba(237, 234, 227, 0.85)',
        height: 14,
        width: 14,
        padding: 8,
      },
      spotlight: {
        borderRadius: '8px',
      },
    }),
    [isLight],
  );

  const handleJoyrideCallback = (data) => {
    const { status, action } = data;

    if (status === 'finished' || status === 'skipped' || action === 'close') {
      onFinish();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      disableScrollParentFix={false}
      callback={handleJoyrideCallback}
      styles={joyrideStyles}
      floaterProps={{
        disableAnimation: false,
        styles: {
          floater: {
            filter: isLight
              ? 'drop-shadow(0 10px 28px rgba(7, 8, 10, 0.12))'
              : 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5))',
          },
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Got it!',
        next: 'Next',
        skip: 'Skip tour',
      }}
    />
  );
}

